import http from '@/utils/http';

(http as any).get = (...args: any[]) => {
  return http({
    method: 'GET',
    url: args?.[0],
    ...args?.[1],
  });
};

(http as any).post = (...args: any[]) => {
  return http({
    method: 'POST',
    url: args?.[0],
    data: args?.[1],
    ...args?.[2],
  });
};

export default http;

/* import axios from 'axios';
import getUid from './mask';
import { Modal } from 'tea-component';
// @ts-ignore
import { doLogout, getAuthorization, getEmbedToken } from './utils';
import {
  messagetip,
  ERROR_CODE_MESSAGE,
  INSTANCE_CONFIG,
  NETWORK_ERROR_MSG,
  TEMP_TOKEN,
} from './common';
// @ts-ignore
import type { ResultType } from '@gp/types/axios';
import log from '../log/aegis';

const instance = axios.create(INSTANCE_CONFIG);

instance.interceptors.request.use(
  (config) => {
    const { headers = {}, url = '' } = config;
    if (checkFresh()) {
      const freshKey = 'cacheRefresh';
      config.url = `${url}${url.indexOf('?') > -1 ? '&' : '?'}${freshKey}=true`;
    }

    // 设置用户信息请求头
    let Authorization = TEMP_TOKEN || getAuthorization();
    if ((window as any).isInIframe) {
      Authorization = getEmbedToken();
      if (!Authorization) {
        return Promise.reject({
          config,
          message: '未获取到token信息'
        });
      }
    }
    config.headers = Authorization ? { ...headers, Authorization } : headers;

    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  (response) => {
    const { headers, data, status, config } = response;
    // @ts-ignore
    const { download, responseType } = config || {};
    const { 'content-type': responseContentType } = headers || {};
    // 文件流下载
    if (download && responseType === 'blob') {
      if (responseContentType === 'application/octet-stream') { // 接口返回 content-type 为 application/octet-stream 代表下载成功
        return response;
      } else { // 否则 代表下载失败
        return Promise.reject(response);
      }
    }
    const { code, msg, data: realData } = (data || {}) as ResultType;
    const { noAuth, errorHandler, noReport, original, formatData, url, method, params, data: requestParams } = config || {};

    switch (true) {
      // 正常数据
      case status === 200 && (code === 200 || code === 0): {
        getUid(headers);
        if (original) return response;
        if (formatData) {
          return formatData(realData);
        }
        return realData;
      }
      // 登录态失效
      // case (status === 401 || code === 40001 || code === 20001 || code === 20002) && !noAuth : {
      case status === 401 && !noAuth: {
        if ((window as any).isInIframe) {
          showLoginTimeOut();
        } else {
          doLogout();
        }
        return Promise.reject(original ? response : data);
      }
      default: {
        const realMsg = original ? (msg || NETWORK_ERROR_MSG) : (ERROR_CODE_MESSAGE[code] || msg || ERROR_CODE_MESSAGE[999]);
        if (!errorHandler) {
          showCommonError(realMsg);
        }
        if (!noReport) {
          log.error({ url, method, params: requestParams || params, status, data });
        }
        return Promise.reject(original ? response : data);
      }
    }
  },
  (error) => {
    const {
      config,
      message,
      response
    } = error;
    const { status , data  } = response ?? {} // 当接口超时时，response会为undefined情况
    const errorMsg = config?.original ? (data?.msg || NETWORK_ERROR_MSG) : (
      ERROR_CODE_MESSAGE[data?.code] ||
      data?.msg ||
      message ||
      ERROR_CODE_MESSAGE[999]
    );

    const { errorHandler, noReport, url, method, data: requestParams, params } = config || {};
    if (!errorHandler) {
      showCommonError(errorMsg);
    }
    if (!noReport) {
      log.error({ url, method, params: requestParams || params, status, data, message });
    }
    return Promise.reject({ code: data?.code || 999, msg: errorMsg });
  },
);

function checkFresh() {
  const str = '_refresh=1';
  if (window.location.search.indexOf(str) > -1) {
    return true;
  }
  if (window.location.hash.indexOf(str) > -1) {
    return true;
  }
  return false;
}

let isShowModal: boolean = false;
function showLoginTimeOut(): void {
  if (!isShowModal) {
    Modal.alert({
      message: '登录过期啦，请刷新页面重试~',
      onClose: () => {
        isShowModal = false;
      }
    } as any);
    isShowModal = true;
  }
}

const showCommonError = (errMsg: string) => {
  errMsg &&
    messagetip({
      content: errMsg,
      duration: 5000,
      isClose: true,
      type: 'error',
    });
};

export default instance;
 */